import { Modal } from 'antd';
import styles from './index.module.sass';
import { useState } from 'react';
import managerSvg from '@@/seller-account/images/manager.svg';
import { ButtonMain } from '@/modules/common/components/button';
import { Notifier } from '../../../../../common/components/notifier';

export const PartnersNotifier = () => {
  const [visible, setVisible] = useState(false);
  return (<>
    <Modal
      open={visible}
      width={426}
      onCancel={() => setVisible(false)}
      footer={
        <div className={styles.modalFooter}>
          <ButtonMain
            className={styles.footerButton}
            label='понятно'
            onClick={() => setVisible(false)}
          />
        </div>
      }
      closeIcon={null}
    >
      <div className={styles.modalRoot}>
        <img src={managerSvg} width={261} alt="manager" />
        <span>
          Ваша заявка отправлена, ожидайте список контрагентов и цен от менеджеров
        </span>
      </div>
    </Modal>
    <Notifier
      bgColor="#66B28A"
      textColor="#FFFFFF"
      heading="Сервис Liliani cможет предоставить список проверенных партнеров-покупателей"
      text="Добавить контрагентов подобранных сервисом?"
      buttonLabel="разрешить интеграцию контрагентов"
      buttonDisabled
      onClick={
        () => {}
        // () => setVisible(true)
      }
    />
  </>);
};
